import React from 'react';
import * as PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';

const MultipleChoiceAnswer = React.forwardRef(
  (
    {
      id,
      questionId,
      description,
      disabled,
      checked,
      selectAnswer,
      correctResponse,
      showRightOrWrong,
    },
    ref
  ) => {
    const handleKeyDown = (e) => {
      // Enable Space key to select the radio button
      if (e.key === ' ' || e.keyCode === 32) {
        e.preventDefault(); // Prevent page scrolling
        if (!checked && !disabled) {
          selectAnswer(id);
        }
      }
    };

    let classes = 'mb-3',
      icon = '';
    if (disabled) {
      classes += ' disabled';
    }
    if (showRightOrWrong) {
      if (correctResponse) {
        classes += ' correct';
        icon = <i className="fa fa-check" />;
      } else {
        classes += ' incorrect';
        icon = <i className="fa fa-remove" />;
      }
    }

    return (
      <div className={classes}>
        <Form.Check
          id={questionId + '-' + id}
          type="radio"
          value={id}
          name={questionId}
          checked={checked}
          disabled={disabled}
          label={<span dangerouslySetInnerHTML={{ __html: description }} />}
          onChange={() => selectAnswer(id)}
          onKeyDown={handleKeyDown}
          ref={ref}
        />
        {icon}
      </div>
    );
  }
);

MultipleChoiceAnswer.propTypes = {
  id: PropTypes.number.isRequired,
  questionId: PropTypes.number.isRequired,
  description: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  selectAnswer: PropTypes.func.isRequired,
  correctResponse: PropTypes.bool,
  showRightOrWrong: PropTypes.bool,
};

MultipleChoiceAnswer.defaultProps = {
  id: 0,
  questionId: 0,
  description: 'Choice',
  disabled: false,
  checked: false,
  correctResponse: false,
  showRightOrWrong: false,
};

MultipleChoiceAnswer.displayName = 'MultipleChoiceAnswer';

export default MultipleChoiceAnswer;
